import {ensureHierarchy, mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {SportsContent} from '../sports-content.js';

import {couponsFactory} from './coupons.factory';

import PALETTE_SCHEMA from './coupons.palette-schema.yaml';
import SCHEMA from './coupons.schema.yaml';

class CouponsFeature extends AbstractVisualFeature {
    get name() {
        return 'Coupons';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    get configSchema() {
        return SCHEMA;
    }

    getVisualConfig(PALETTE) {
        return couponsFactory(PALETTE);
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        const configurations = ensureHierarchy(mojitoConfig, 'services.configurations');

        mergeTo(configurations, {
            MatchesCoupon: {
                eventsCoupon: {
                    initialExpandedGroups: this.config.eventsCouponInitialExpandedGroupsAmount,
                },
            },
            CmsSportCouponView: {
                eventCoupon: {
                    initialExpandedGroups: this.config.cmsSportCouponInitialExpandedGroupsAmounts,
                },
            },
            SingleLeagueCoupon: {
                eventsCoupon: {
                    initialExpandedGroups: this.config.singleLeagueCouponInitialExpandedGroupsAmount,
                },
            },
            InPlayContent: {
                sportTab: {
                    eventsCoupon: {
                        initialExpandedGroups: this.config.sportTabCouponInitialExpandedGroupsAmount,
                    },
                },
                allTab: {
                    eventsCoupon: {
                        initialExpandedGroups: this.config.allTabCouponInitialExpandedGroupsAmount,
                    },
                },
            },
        });

        return super.beforeMojitoConfigBuild(mojitoConfig);
    }
}

new CouponsFeature(SportsContent);
